export const LOCALIZED_PRICING_ROUTES = ["en-in", "en-id", "en-ph", "en-br", "en-my"]
export const LOCALIZED_PRICING_ROUTES_FOR_COUNTRIES = { 
    'IN': '/en-in',
    'ID': '/en-id',
    'PH': '/en-ph',
    'BR': '/en-br',
    'MY': '/en-my'
}